export function isNullOrUndefined(object: unknown): boolean {
    if (typeof object !== 'undefined' && object !== null) {
        return false;
    } else {
        return true;
    }
}

export class StringUtil {
    private static readonly ALPHANUMERIC_CHARSET: string =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    public static randomString(length = 12): string {
        let outString = '';

        for (let i = 0; i < 32; i++) {
            outString += StringUtil.ALPHANUMERIC_CHARSET.charAt(
                Math.floor(Math.random() * StringUtil.ALPHANUMERIC_CHARSET.length)
            );
        }

        return outString;
    }

    public static isString(something: any): boolean {
        return typeof something === 'string';
    }

    public static isValid(str: string): boolean {
        return !isNullOrUndefined(str) && str !== '';
    }

    public static extractOnlyNumberFromString(string: string): number {
        return parseInt(string.replace(/[^0-9\.]/g, ''), 10);
    }

    public static replaceAll(str: string, find: any, replacement: any): string {
        return str.split(find).join(replacement);
    }

    public static copyText(val: string): void {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    public static extractUrls(string: string, toLowerCase?: boolean, removeDuplicates?: boolean): Array<string> | undefined {
        const regexp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?!&//=]*)/gi;
        // const regexp = /https?:\/\/(.+?)((?=\s)|(?=$))/gi;

        let urls: Array<string> | null = string.match(regexp);
        if (urls) {

            if (removeDuplicates) {
                urls = urls.filter((url, i) => (urls as Array<string>).indexOf(url) === i);
            }

            return toLowerCase ? urls.map((item) => item.toLowerCase()) : urls;
        }
    }


}
